import React from 'react'
import "./PlainImgTextContent.css"
import { useNavigate } from 'react-router-dom';

function PlainImgTextContent({
    heading="",
    content="",
    btnText="",
    btnRef="/",
    bgColor="white",
    fontThemeDark=false,
    btnClass="btn-dark",
    contentImg="",
    shortImg=false
}) {
    const paragraphs = content.split('\n').map((paragraph, index) => <p key={index} className={`body-paragraph my-1 mb-3 ${!fontThemeDark && "color-light"}`}>{paragraph}</p>);
    const navigate = useNavigate()
  return (
    <div className='PlainImgTextContent-container standard-padding-space'  style={{backgroundColor:`${bgColor}`}}>
        <div className='container'>
            <div className='row gy-lg-0 gy-5 flex-lg-row flex-column-reverse'>
                <div className='col-lg-6 d-flex'>
                     <div className='text-start content-container my-auto'>
                        <h3 className={`body-heading ${!fontThemeDark && "color-light"} `}>{heading}</h3>
                        <div className={`body-paragrpah ${!fontThemeDark && "color-light"} my-3 py-3`}>{paragraphs}</div>
                        <button className={`genral-btn ${btnClass}`} onClick={()=>{navigate(btnRef)}}>{btnText}</button>
                    </div>
                </div>
                <div className={`col-lg-6 ${shortImg?"text-center":"text-end"}`}>
                     <img src={contentImg} alt='content' className='img-fluid' style={{maxHeight:`${shortImg?"430px":"auto"}`}} />
                </div>

            </div>

        </div>
    </div>

  )
}

export default PlainImgTextContent